import { Locale } from 'date-fns';
import { enUS, hr, hu, sk } from 'date-fns/locale';

export const localeMap: Record<string, Locale> = {
  en: enUS,
  hu: hu,
  sk: sk,
  hr: hr,
};
